import { render, staticRenderFns } from "./ConfirmLabManager.vue?vue&type=template&id=ca42abc8"
import script from "./ConfirmLabManager.vue?vue&type=script&lang=js"
export * from "./ConfirmLabManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports